/**
 * Shared constants for EVM <-> non-EVM wallet association flows (Solana, TON).
 * Kept free of magic numbers / inline literals per project conventions.
 */

export const ASSOCIATION_API_BASE = process.env.REACT_APP_API_SECONDARY ?? "";

export const ASSOCIATION_ROUTES = {
  solana: "/wallet/association",
  ton: "/wallet/ton-association",
} as const;

export const ASSOCIATION_HTTP_STATUS = {
  CREATED: 201,
  BAD_REQUEST: 400,
  NOT_FOUND: 404,
  CONFLICT: 409,
} as const;

export const ASSOCIATION_MESSAGES = {
  CHECK_SERVICE_UNAVAILABLE:
    "Wallet association service is not available. Please try again later.",
  CHECK_FAILED: "Failed to check wallet association",
  CREATE_SERVICE_UNAVAILABLE:
    "Association service is not available. Please try again later.",
  INVALID_ADDRESS: "Invalid wallet address format",
  CREATE_FAILED: "Failed to create wallet association",
} as const;

export const TON_CONNECT_TEXT = {
  CONNECT_EVM_FIRST: "Connect EVM wallet first",
  CONNECT_WALLET: "Connect TON Wallet",
  CONNECTING: "Connecting...",
  ASSOCIATING: "Associating wallets automatically...",
  ASSOCIATION_IN_PROGRESS: "Wallet connected, association in progress...",
  DISCONNECT: "Disconnect",
  SECTION_TITLE: "TON Wallet Required",
  SECTION_DESCRIPTION:
    "This IDO requires both EVM and TON wallet connections. Association happens automatically after connection.",
} as const;

export const TON_ADDRESS_PREVIEW = {
  HEAD: 4,
  TAIL: 4,
} as const;
